var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1Dsk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1328,
    viewBox: "0 0 1920 1328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-40.0425 962.057C-389.822 827.369 -406.113 523.923 -453.791 464.517L-3.37431 0.125931C-3.37431 0.125931 96.1641 1298.08 850.655 566.175C1605.15 -165.728 1997.52 323.884 1997.52 323.884C1990.84 1396.69 2050.15 1490.01 1929.51 1157.01C1752.62 668.739 1222.24 717.565 965.194 784.654C495.367 907.277 253.637 1075.14 -40.0425 962.057Z",
    fill: "url(#paint0_linear_3_678)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_678",
    x1: 773.407,
    y1: 1319.99,
    x2: 773.407,
    y2: 195.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B66CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC8EF",
    stopOpacity: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1Dsk);
export default __webpack_public_path__ + "static/media/vector1dsk.7eebae5b35b7dcba612627240c6f1e7b.svg";
export { ForwardRef as ReactComponent };